var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"450px","height":"224px"},attrs:{"id":"usage-cpu-chart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }